<template>
  <div class="ce-tool">
    <div class="editor-pane" v-if="!imageUrl">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.ColorExtractor.title') }}</span>
        <span class="pane-hint">PNG / JPEG / WebP / GIF · Max 50MB</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1" accept="image/png,image/jpeg,image/webp,image/bmp,image/gif" :file-list="fileList">
        <i class="el-icon-picture-outline" style="font-size:42px;color:#c0c4cc;" />
        <div class="el-upload__text">{{ $t("tool.ColorExtractor.dropText") }}<em>{{ $t("tool.ColorExtractor.clickUpload") }}</em></div>
      </el-upload>
    </div>

    <div class="editor-pane" v-if="imageUrl">
      <div class="pane-header">
        <span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.ColorExtractor.title') }}</span>
        <span class="pane-hint">十字光标定位</span>
        <el-button size="small" @click="reset" style="margin-left:8px;">{{ $t('tool.ColorExtractor.reupload') }}</el-button>
      </div>
      <div class="ce-image-area">
        <canvas ref="canvas" class="ce-canvas" @click="pickColor" @mousemove="onMove" @mouseleave="onLeave" />
      </div>
      <div class="ce-panel" v-if="pickedColor">
        <div class="ce-swatch" :style="{background:pickedColor}" />
        <div class="ce-info">
          <div class="ce-row"><span>HEX</span><code>{{ hex }}</code><span class="ce-copy" @click="copy(hex)"><i class="el-icon-document-copy" /></span></div>
          <div class="ce-row"><span>RGB</span><code>{{ rgb }}</code><span class="ce-copy" @click="copy(rgb)"><i class="el-icon-document-copy" /></span></div>
          <div class="ce-row"><span>HSL</span><code>{{ hsl }}</code><span class="ce-copy" @click="copy(hsl)"><i class="el-icon-document-copy" /></span></div>
        </div>
      </div>
      <div class="ce-recent" v-if="recentColors.length">
        <span class="ce-recent-lbl">历史取色</span>
        <span v-for="(c,i) in recentColors" :key="i" class="ce-dot" :style="{background:c}" @click="pickedColor=c" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ColorExtractorTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],imageUrl:'',pickedColor:'',recentColors:[],ctx:null,imgW:0,imgH:0}),
  computed:{
    hex(){return this.pickedColor.startsWith('#')?this.pickedColor.toUpperCase():this.r2h(this.pickedColor)},
    rgb(){return this.pickedColor.startsWith('#')?this.h2r(this.pickedColor):this.pickedColor},
    hsl(){return this.r2hsl(this.rgb)}
  },
  methods:{
    handleFile(f){if(f.size>50*1024*1024){this.$message.error('最大50M');return}this.file=f.raw;this.fileList=[f];const r=new FileReader();r.onload=e=>{this.imageUrl=e.target.result;this.$nextTick(()=>this.initCanvas())};r.readAsDataURL(f.raw)},
    initCanvas(){const c=this.$refs.canvas;if(!c)return;const img=new Image();img.onload=()=>{const max=700,s=Math.min(1,max/img.width);c.width=img.width*s;c.height=img.height*s;const ctx=c.getContext('2d');ctx.drawImage(img,0,0,c.width,c.height);this.ctx=ctx;this.imgW=c.width;this.imgH=c.height};img.src=this.imageUrl},
    pick(e){const r=this.$refs.canvas.getBoundingClientRect();const x=Math.round((e.clientX-r.left)*(this.imgW/r.width)),y=Math.round((e.clientY-r.top)*(this.imgH/r.height));const p=this.ctx.getImageData(x,y,1,1).data;const c='#'+[p[0],p[1],p[2]].map(v=>v.toString(16).padStart(2,'0')).join('');this.pickedColor=c;if(!this.recentColors.includes(c)){this.recentColors.unshift(c);if(this.recentColors.length>12)this.recentColors.pop()}},
    pickColor(e){this.pick(e)},
    onMove(e){if(this.$refs.canvas)this.$refs.canvas.style.cursor='crosshair'},
    onLeave(){},
    reset(){this.imageUrl='';this.file=null;this.fileList=[];this.pickedColor='';this.recentColors=[]},
    h2r(h){const r=parseInt(h.slice(1,3),16),g=parseInt(h.slice(3,5),16),b=parseInt(h.slice(5,7),16);return`rgb(${r},${g},${b})`},
    r2h(r){const m=r.match(/\d+/g);return m?'#'+m.slice(0,3).map(v=>parseInt(v).toString(16).padStart(2,'0')).join(''):''},
    r2hsl(r){const m=r.match(/\d+/g);if(!m)return'';let[r2,g2,b2]=m.map(v=>parseInt(v)/255);const max=Math.max(r2,g2,b2),min=Math.min(r2,g2,b2);let h=0,s,l=(max+min)/2;if(max!==min){const d=max-min;s=l>.5?d/(2-max-min):d/(max+min);h=max===r2?((g2-b2)/d+(g2<b2?6:0))/6:max===g2?((b2-r2)/d+2)/6:((r2-g2)/d+4)/6}return`hsl(${Math.round(h*360)},${Math.round(s*100)}%,${Math.round(l*100)}%)`},
    copy(t){navigator.clipboard.writeText(t);this.$message.success(this.$t("common.status.copied"))},
    doAction(a){if(a==='clear')this.reset();if(a==='copy'&&this.hex){navigator.clipboard.writeText(this.hex);this.$message.success(this.$t("common.status.copied"))}}
  }
}
</script>

<style scoped>
.ce-tool { display:flex;flex-direction:column;gap:16px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; }
.editor-pane ::v-deep .el-upload-dragger { display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; }

.ce-image-area { text-align:center;margin-bottom:12px; }
.ce-canvas { max-width:100%;border:1px solid #e4e7ed;border-radius:8px;cursor:crosshair; }

.ce-panel { display:flex;align-items:center;gap:16px;padding:12px 16px;background:#fff;border-radius:8px;border:1px solid #e4e7ed; }
.ce-swatch { width:52px;height:52px;border-radius:10px;flex-shrink:0;border:1px solid #e4e7ed; }
.ce-info { flex:1;display:flex;flex-direction:column;gap:4px; }
.ce-row { display:flex;align-items:center;gap:8px; }
.ce-row span { font-size:11px;font-weight:600;color:#8892a6;width:28px; }
.ce-row code { flex:1;font-size:13px;font-family:monospace;color:#303133; }
.ce-copy { width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:4px;cursor:pointer;color:#b0b8c4;transition:all .15s; }
.ce-copy:hover { background:#f0f4ff;color:#4e7cff; }

.ce-recent { display:flex;align-items:center;gap:6px;margin-top:10px; }
.ce-recent-lbl { font-size:11px;color:#8892a6;margin-right:4px; }
.ce-dot { width:20px;height:20px;border-radius:50%;cursor:pointer;border:2px solid #e4e7ed;transition:transform .15s; }
.ce-dot:hover { transform:scale(1.2);border-color:#4e7cff; }

.editor-pane ::v-deep .el-upload { width:100%; }
::v-deep .el-upload-dragger { max-width:100%; width:100%; box-sizing:border-box; display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; }
</style>
